module.exports = __webpack_public_path__ + "img/system_4.64eec16d.jpg";